import { createTheme } from '@fluentui/react';

export const myTheme = createTheme({
  palette: {
    themePrimary: '#90cc34',
    themeLighterAlt: '#fafdf5',
    themeLighter: '#ebf7d9',
    themeLight: '#daf0ba',
    themeTertiary: '#b8e07b',
    themeSecondary: '#9bd247',
    themeDarkAlt: '#81b82e',
    themeDark: '#6d9b27',
    themeDarker: '#50721d',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  }
});